import merge from 'lodash.merge';
import queryString from 'query-string';
import { useHistory } from 'react-router';
export const useSearchParams = (selection) => {
    let search = { query: '' };
    const history = useHistory();
    if (history.location.search) {
        const searchParsed = queryString.parse(history.location.search);
        search = merge(search, searchParsed);
    }
    if (selection) {
        return selection.reduce((paramsMap, name) => {
            // It being potentially undefined in the object is sort of the desired behaviour.
            paramsMap[name] = search[name];
            return paramsMap;
        }, {});
    }
    return search;
};
//# sourceMappingURL=searchParams.js.map